<template>
    <div class="sidebar-container ">
        <div class="sidebar">
            <img src="../assets/icons/logo_yams.svg" alt="logo" class="mx-auto p-3 mb-3" style="width: 100%;">

            <nav class="navys flex-column justify-content-top">
                <router-link class="navys-link" :to="{ name: 'accueil' }"
                    :class="{ 'active': this.$route.name === 'accueil' }" data-bs-toggle="tooltip"
                    data-bs-placement="right" title="Accueil">
                    <img src="@/assets/icons/Home/home.svg" alt="icone">
                </router-link>
                <router-link class="navys-link" :to="{ name: 'courses' }"
                    :class="{ 'active': (this.$route.name === 'courses') || (this.$route.name === 'reservations') || (this.$route.name === 'livraisons') || (this.$route.name === 'reservations.single') }"
                    data-bs-toggle="tooltip" data-bs-placement="right" title="Courses">
                    <img src="@/assets/icons/Operations.svg" alt="icone">
                </router-link>
                <router-link class="navys-link" :to="{ name: 'factures' }"
                    :class="{ 'active': this.$route.name === 'factures' }" data-bs-toggle="tooltip"
                    data-bs-placement="right" title="Factures">
                    <img src="@/assets/icons/Compta.svg" alt="icone">
                </router-link>
                <router-link class="navys-link" :to="{ name: 'geolocalisation' }"
                    :class="{ 'active': this.$route.name === 'geolocalisation' }" data-bs-toggle="tooltip"
                    data-bs-placement="right" title="Geolocalisation">
                    <img src="@/assets/icons/Geolocalisation.svg" alt="icone">
                </router-link>
                <!-- <router-link class="navys-link" :to="{ name: 'tickets' }"
                    :class="{ 'active': this.$route.name === 'tickets' }" data-bs-toggle="tooltip"
                    data-bs-placement="right" title="Chat">
                    <img src="@/assets/icons/messages.svg" alt="icone">
                </router-link> -->
            </nav>

            <!-- Éléments en bas de la sidebar -->
            <div class="sidebar-bottom">

                <!-- Bouton notifications - visible seulement en mobile -->
                <div class="sidebar-action-btn d-lg-none" data-bs-toggle="tooltip" data-bs-placement="right"
                    title="Notifications" @click="openNotificationsModal">
                    <i class="far fa-bell"></i>
                    <span v-if="notificationCount > 0" class="notification-badge">{{ notificationCount }}</span>
                </div>

                <!-- Profile dropdown - visible seulement en mobile -->
                <div class="profile-section d-lg-none">
                    <div class="profile-img" @click="toggleProfileDropdown" data-bs-toggle="tooltip"
                        data-bs-placement="right" title="Profil">
                        <img :src="userPhoto" class="rounded-circle" alt="Photo de profil">
                    </div>

                    <!-- Profile dropdown menu -->
                    <div class="profile-dropdown" :class="{ 'show': isProfileDropdownOpen }">
                        <div class="profile-dropdown-header">
                            <img :src="userPhoto" class="rounded-circle" alt="Photo de profil">
                            <div class="profile-info">
                                <div class="profile-name">{{ userName }}</div>
                            </div>
                        </div>
                        <div class="profile-dropdown-body">
                            <div class="profile-dropdown-item" @click="openProfileModal">
                                <i class="fa-regular fa-user"></i>
                                <span>Profil</span>
                            </div>
                            <div class="profile-dropdown-item logout" @click="logout">
                                <i class="fa-solid fa-arrow-right-from-bracket"></i>
                                <span>Se déconnecter</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
const NotificationComponent = defineAsyncComponent(() => import('@/components/NotificationComponent.vue'));
const MyProfile = defineAsyncComponent(() => import('@/auth/MyProfile.vue'));

export default defineComponent({
    name: 'SideBar',
    data() {
        return {
            isFullscreen: false,
            isProfileDropdownOpen: false
        }
    },
    computed: {
        ...mapGetters(['notificationCount']),
        userName() {
            return this.$store.getters.user?.nom || '';
        },
        userPhoto() {
            return this.$store.getters.user?.photo || '';
        }
    },
    mounted() {
        document.addEventListener('fullscreenchange', this.onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
        document.addEventListener('mozfullscreenchange', this.onFullscreenChange);
        document.addEventListener('MSFullscreenChange', this.onFullscreenChange);

        // Ferme le dropdown si on clique à l'extérieur
        document.addEventListener('click', this.closeDropdownOnClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('fullscreenchange', this.onFullscreenChange);
        document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
        document.removeEventListener('mozfullscreenchange', this.onFullscreenChange);
        document.removeEventListener('MSFullscreenChange', this.onFullscreenChange);

        document.removeEventListener('click', this.closeDropdownOnClickOutside);
    },
    methods: {
        ...mapActions(['stopFetchingNotifications']),
        openNotificationsModal() {
            this.$dialog.open(NotificationComponent, {
                props: {
                    header: "Notifications",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
            });
        },
        openProfileModal() {
            this.$dialog.open(MyProfile, {
                props: {
                    header: "Mon compte",
                    style: {
                        width: '40vw'
                    },
                    modal: true
                },
            });
            this.isProfileDropdownOpen = false;
        },
        toggleProfileDropdown(event) {
            event.stopPropagation();
            this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
        },
        closeDropdownOnClickOutside(event) {
            const profileSection = document.querySelector('.profile-section');
            if (this.isProfileDropdownOpen &&
                profileSection &&
                !profileSection.contains(event.target)) {
                this.isProfileDropdownOpen = false;
            }
        },
        logout() {
            this.$router.push({ name: 'login' });
            this.$store.commit('clearUserData');
            this.stopFetchingNotifications();

            this.axios.post('/api/logout').then(response => {
                if (response.data.success === true) {
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                } else {
                    response.data.errors.forEach(element => {
                        this.$toast.error(element, {
                            duration: '8000',
                            position: 'top-left'
                        });
                    });
                }
            }).catch(() => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            });
        }
    }
});
</script>

<style scoped>
.sidebar-container {
    position: relative;
    height: 100vh;
}

.sidebar {
    width: 80px;
    height: 100%;
    border-right: 1px solid #eef2f7;
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.navys {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
}

.navys-link {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d;
    padding: 15px 0;
    position: relative;
    margin: 10px 0;
    width: 100%;
    height: 55px;
    transition: all 0.3s ease;
}

.navys-link img {
    width: 24px;
    height: 24px;
}

.navys-link.active {
    background-color: #3242C4;
    /* Bleu comme sur la maquette */
    color: #ffffff;
}


.navys-link:hover:not(.active) {
    background-color: rgba(50, 66, 196, 0.1);
    /* Couleur légèrement bleutée au survol */
}

/* Styles pour les boutons en bas de la sidebar */
.sidebar-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    margin-top: auto;
}

.sidebar-action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin: 8px 0;
    cursor: pointer;
    color: #6c757d;
    position: relative;
    transition: all 0.3s ease;
}

.sidebar-action-btn:hover {
    background-color: rgba(0, 123, 255, 0.1);
    color: #007bff;
}

.sidebar-action-btn i {
    font-size: 1.2rem;
}

/* Badge de notification */
.notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #dc3545;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    font-size: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Section profil */
.profile-section {
    position: relative;
    margin-top: 10px;
}

.profile-img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid #eef2f7;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.profile-img:hover {
    border-color: #007bff;
    transform: translateY(-2px);
}

.profile-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Menu dropdown du profil - Design modernisé */
.profile-dropdown {
    position: absolute;
    left: 70px;
    bottom: 0;
    width: 280px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    opacity: 0;
    visibility: hidden;
    transform: translateX(-15px);
    transition: all 0.35s cubic-bezier(0.25, 1, 0.5, 1);
    z-index: 1000;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.profile-dropdown.show {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
}

.profile-dropdown-header {
    padding: 20px;
    background: linear-gradient(45deg, #f8f9fa, #ffffff);
    display: flex;
    align-items: center;
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.profile-dropdown-header:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #007bff, #00c6ff);
}

.profile-dropdown-header img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-right: 12px;
    object-fit: cover;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
    border: 2px solid white;
}

.profile-info {
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.profile-name {
    font-weight: 600;
    color: #2d3748;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 2px;
}

.profile-dropdown-body {
    padding: 8px 0;
}

.profile-dropdown-item {
    padding: 12px 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease;
    margin: 2px 8px;
    border-radius: 8px;
}

.profile-dropdown-item:hover {
    background-color: rgba(0, 123, 255, 0.08);
    transform: translateX(3px);
}

.profile-dropdown-item i {
    margin-right: 12px;
    font-size: 1.1rem;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    color: #007bff;
    background-color: rgba(0, 123, 255, 0.1);
}

.profile-dropdown-item span {
    font-weight: 500;
    color: #4a5568;
}

.profile-dropdown-item.logout {
    margin-top: 6px;
    color: #e53e3e;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    margin-top: 8px;
    padding-top: 14px;
}

.profile-dropdown-item.logout:hover {
    background-color: rgba(229, 62, 62, 0.08);
}

.profile-dropdown-item.logout i {
    color: #e53e3e;
    background-color: rgba(229, 62, 62, 0.1);
}
</style>
